<template>
    <div>
        <div class="home">
            <img src="../assets/img/home/bg-home.svg" class="home--bg" alt="" />

            <div class="container-lg d-flex flex-column pt-4">
                <div class="d-flex justify-content-between">
                    <img src="../assets/img/home/logo-ref21.svg" class="home--logo" alt="" />
                    <img src="../assets/img/home/logo-medef.svg" class="home--logo" alt="" />
                </div>
                <div class="position-relative d-flex justify-content-center mb-5">
                    <router-link class="home--btn-billeterie btn btn-lg btn-outline-primary d-none d-md-block" to="/billetterie">
                        BILLETTERIE
                    </router-link>

                    <img src="../assets/img/home/logo-mutation.png" class="home--logo-mutation" alt="" />

                    <div class="home--menu d-none d-md-block">
                        <router-link to="/#programme" class="menu-item">
                            <img src="../assets/img/home/bulles-menu1.svg" alt="" />
                            <span>Programme</span>
                        </router-link>
                        <router-link to="/#intervenants" class="menu-item">
                            <img src="../assets/img/home/bulles-menu2.svg" alt="" />
                            <span>Intervenants</span>
                        </router-link>
                        <router-link to="/#acces" class="menu-item">
                            <img src="../assets/img/home/bulles-menu3.svg" alt="" />
                            <span>Accès & Infos</span>
                        </router-link>
                        <router-link to="/#partenaires" class="menu-item">
                            <img src="../assets/img/home/bulles-menu4.svg" alt="" />
                            <span>Partenaires</span>
                        </router-link>
                    </div>
                </div>

                <router-link class="btn btn-lg btn-outline-primary align-self-center d-md-none" to="/billetterie"> BILLETTERIE </router-link>

                <div class="home--text">
                    Cette 12ème édition de la REF21 sera axée sur la thématique « MUTATION(S) » et développée, grâce à nos conférenciers, au travers
                    d'une même volonté de repenser l'entrepreneuriat.
                </div>
            </div>
        </div>

        <div class="container text-center home-presentation my-5">
            <h1 class="fs-4 fw-bold">MUTATION : vient du latin mutare qui signifie changer.</h1>

            <div class="separation"></div>

            <p>
                Le monde d'aujourd'hui change et nous ne pouvons plus le nier. A cela ajoutez un grain de sable comme une guerre ou une épidémie et
                c'est tout le système qui est chamboulé.
            </p>

            <p>
                Pourtant, on aurait tort de penser que les chamboulements dont est victime notre société seraient une fin en soi. Le monde change oui,
                mais si nous en faisions avant tout une opportunité ? <br />Ne pas être simple spectateur mais agir ! S'affranchir des règles et
                devenir acteur du changement.
            </p>

            <p>
                Le monde de l'entreprise en fait partie. Des hommes et des femmes qui s'évertuent à s'adapter à ce changement, à bouger les lignes, à
                les brusquer, voir même à les transformer.
            </p>

            <p>Une métamorphose se joue sous nos yeux et nous pouvons apprendre à Déconstruire pour mieux créer.</p>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
};
</script>
